import { useMemo } from "react";

/**
 * Note: this is a hard coded list of displayable categories. This is necessary to
 * filter out categories that are not considered categories in the UI but returned
 * from the API. For example, "email_hub" is a API category but it should not be
 * displayed as a category in the UI.
 */
const CATEGORIES = [
  "onboarding",
  "engagement",
  "administrative",
  "paywalls",
  "ai_workflows",
  "moderation",
];

const EMAIL_HUB_CATEGORY = "email_hub";

const AI_WORKFLOWS_CATEGORY = "ai_workflows";

const AI_ACTION_CATEGORY = "ai_agent";

/**
 * Derives the category and whether the template is an email hub template from the
 * categories array. We assume the main category is the first one in the array that
 * is in the CATEGORIES array.
 *
 * @param categories - The workflow template categories array.
 * @returns The category and whether the template is an email hub template.
 */
export function useDeriveCategoryAndLabelsFromCategories(
  categories: string[],
): {
  category: string | undefined;
  isEmailHub: boolean;
  isAiAgent: boolean;
} {
  const { category, isEmailHub, isAiAgent } = useMemo(() => {
    let hasEmailHubCategory = false;
    let hasAiAgentCategory = false;

    const onlyCategories = categories.filter((category: string) => {
      if (!hasEmailHubCategory && category === EMAIL_HUB_CATEGORY) {
        hasEmailHubCategory = true;
      }

      if (!hasAiAgentCategory && category === AI_ACTION_CATEGORY) {
        hasAiAgentCategory = true;
      }

      if (!hasAiAgentCategory && category === AI_WORKFLOWS_CATEGORY) {
        hasAiAgentCategory = true;
      }

      return CATEGORIES.includes(category);
    });

    return {
      category: onlyCategories?.[0],
      isEmailHub: hasEmailHubCategory,
      isAiAgent: hasAiAgentCategory,
    };
  }, [categories]);

  return { category, isEmailHub, isAiAgent };
}
